import { render, staticRenderFns } from "./AdvancedReport.vue?vue&type=template&id=979a1afa&"
import script from "./AdvancedReport.vue?vue&type=script&lang=js&"
export * from "./AdvancedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/CBK/BPI/v1.0.9/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBreadcrumbs,VBtn,VCard,VCardText,VCardTitle,VCheckbox,VContainer,VDataTable,VDatePicker,VDialog,VDivider,VFlex,VIcon,VLayout,VMenu,VSelect,VSpacer,VTextField})
